var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-sticky',[_c('div',{staticClass:"box t-a-c font-s-16 flex jcsb bgc-white"},[_c('div',[_c('i',{staticClass:"iconfont icon-zuojiantou",on:{"click":_vm.goback}})]),_c('div',[_vm._t("middle")],2),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }